import throttle from '@/utils/throttle';

export default function(dom, opts) {
	let options = {
		selector: '[data-marquee]',
		factor: 0.1,
		...opts
	};

	const elements = Array.from(dom.querySelectorAll(options.selector));
	const firstElement = elements[0];

	function resize() {
		const pxPerSecond = Math.round(window.innerWidth * options.factor);
		const speed = Math.round(firstElement.clientWidth / pxPerSecond);

		elements.forEach(element => {
			element.style.animationDuration = `${speed}s`;
		});
	}

	window.addEventListener('resize', throttle(resize));
	window.addEventListener('load', resize);

	resize();
}
